"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FOR_SIX_PAYMENTS = exports.FOR_THREE_PAYMENTS = exports.FOR_TWO_PAYMENT = exports.FOR_ONE_PAYMENT = exports.FOR_PACK_TCR = exports.FOR_COMPLETE_AUTOPX = exports.FOR_COMPLETE = void 0;
// Vehicle (paquete completo)
exports.FOR_COMPLETE = 10;
// Vehicle AutoPX
exports.FOR_COMPLETE_AUTOPX = 11;
// VehicleRC_PACK PREMIUM TCR
exports.FOR_PACK_TCR = 2;
/**
 * One payment applies to:
 * - Every CLAVE payment
 * - Third Parties RC Cash Payment and Yappy Payment.
 * - Third Parties RC_PACK Basic & Plus
 */
exports.FOR_ONE_PAYMENT = 1;
/**
 * Two payment applies to:
 * - Third Parties RC_PACK Premium
 */
exports.FOR_TWO_PAYMENT = 2;
/**
 * Four payments applies to:
 * - Third Parties RC Default
 * - Third Parties RC Credit Card (TCR) payment or ACH Payment
 */
exports.FOR_THREE_PAYMENTS = 3;
/**
 * Six payments applies to:
 * Vehicle Cash Payment and Vehicle Yappy Payment
 */
exports.FOR_SIX_PAYMENTS = 6;
//# sourceMappingURL=maxPaymentQuantities.js.map